import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../components/PrimaryButton";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import YellowCheck from "../assets/icons/yellowBgCheck.svg";
import bluecheck from "../assets/icons/blueBgCheck.svg";
import MemeberShipBenefits from "../components/MemeberShipBenefits";
import AppointmentForm from "../components/AppointmentForm";
import FB from "../assets/icons/footer-fb.svg";
import Insta from "../assets/icons/footer-insta.svg";
import Twitter from "../assets/icons/footer-twitter.svg";
import linkdin from "../assets/icons/footer-in.svg";
import phoneIcon from "../assets/images/phoneIcon.svg";
import bulletIcon from "../assets/icons/bulletIcon.svg";
import Footer from "../components/Footer";
import blogImage1 from "../assets/images/blogImage1.png";
import blogImage2 from "../assets/images/blogImage2.png";
import SearchIcon from "../assets/icons/searchIcon.svg";
import RecentNews1 from "../assets/images/recentNews1.png";
import RecentNews2 from "../assets/images/recentNews2.png";
import RecentNews3 from "../assets/images/recentNews3.png";

export default function NewsandUpdates() {
  const [hovered, setHovered] = useState("membership");
  const [activeFilter, setActiveFilter] = useState("All");
  const navigate = useNavigate();
  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "News",
      active: hovered === "news" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("news"),
      onMouseLeave: () => setHovered("news"),
    },
  ];

  const Articles = [
    {
      id: 1,
      image: blogImage1,
      label: "Blog",
      title: "What Is Preventive Care and Why Does It Matter?",
      category: "Medical Innovations",
      date: "January 12, 2024",
    },
    {
      id: 2,
      image: blogImage2,
      label: "Blog",
      title: "The Link Between Diabetes and Heart Disease",
      category: "Medical Innovations",
      date: "January 12, 2024",
    },
    {
      id: 3,
      image: blogImage1,
      label: "Blog",
      title: "What Is Preventive Care and Why Does It Matter?",
      category: "Medical Innovations",
      date: "January 12, 2024",
    },
    {
      id: 4,
      image: blogImage2,
      label: "Blog",
      title: "The Link Between Diabetes and Heart Disease",
      category: "Medical Innovations",
      date: "January 12, 2024",
    },
    {
      id: 5,
      image: blogImage2,
      label: "Blog",
      title: "The Link Between Diabetes and Heart Disease",
      category: "Medical Innovations",
      date: "January 12, 2024",
    },
    {
      id: 6,
      image: blogImage2,
      label: "Blog",
      title: "The Link Between Diabetes and Heart Disease",
      category: "Medical Innovations",
      date: "January 12, 2024",
    },
    {
      id: 7,
      image: blogImage2,
      label: "Blog",
      title: "The Link Between Diabetes and Heart Disease",
      category: "Medical Innovations",
      date: "January 12, 2024",
    },
    {
      id: 8,
      image: blogImage2,
      label: "Blog",
      title: "The Link Between Diabetes and Heart Disease",
      category: "Medical Innovations",
      date: "January 12, 2024",
    },
  ];

  const categories = [
    "Company News",
    "Health Tips",
    "Patient Stories",
    "Medical Team Highlights",
    "Community Programs",
  ];

  const recentNews = [
    {
      img: RecentNews1,
      date: "Aug 02, 2025",
      title: "Meet Nurse Clarisse — 15 Years of Compassionate Care",
    },
    {
      img: RecentNews2,
      date: "July 12, 2025",
      title: "New Skilled Nursing Infusion Therapy Program",
    },
    {
      img: RecentNews3,
      date: "July 02, 2025",
      title: "500 Sponsor Families and Counting",
    },
  ];

  const socialLinks = [
    { link: "#", icon: FB },
    { link: "#", icon: linkdin },
    { link: "#", icon: Twitter },
    { link: "#", icon: Insta },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#007f5f0a",
      }}
    >
      <Header />
      {/* hero section */}
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          minHeight: "100vh",
          marginTop: -45,
        }}
      >
        {/* Breadcrumbs */}
        <div
          style={{
            position: "absolute",
            top: "80px",
            left: "30px",
            zIndex: 1,
          }}
        >
          <Breadcrumbs items={breadcrumbItems} />
        </div>

        {/* Background Image */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            minHeight: "80vh",
            zIndex: -2,
          }}
        >
          <div
            style={{
              backgroundColor: "#007F5F14",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              transition: "opacity 1s ease-in-out",
            }}
          />
        </div>

        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            minHeight: "100vh",
            background: "linear-gradient(180deg, #00000000 , #E5EFEA)",
            zIndex: -1,
          }}
        />

        {/* Hero Content */}
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            marginTop: 50,
          }}
        >
          <p
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "#004E89",
              margin: 0,
            }}
          >
            News
          </p>
          <h1
            style={{
              color: "#007F5F",
              fontSize: 44,
              fontWeight: "600",
              margin: 0,
              textAlign: "center",
            }}
          >
            News & Updates
          </h1>
          <p
            style={{
              color: "#2E2E2E",
              fontSize: 18,
              margin: "24px 0 32px 0",
              textAlign: "center",
              maxWidth: 600,
              margin: 0,
            }}
          >
            Latest stories, health tips, and company milestones from VeriMED
          </p>
        </div>
      </div>
      <div
        style={{
          width: "85%",
          paddingTop: "60px",
          paddingBottom: "60px",
          display: "flex",
          gap: "40px",
        }}
      >
        {/* Left Column */}
        <div
          style={{
            width: "75%",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          {/* Filters + Search */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <div style={{ display: "flex", gap: "12px" }}>
              {["All", "Blogs", "News"].map((label, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveFilter(label)}
                  style={{
                    background:
                      label === activeFilter
                        ? "linear-gradient(180deg, #F0C330 -48.39%, #B78520 100%)"
                        : "#fff",
                    border:
                      label === activeFilter ? "none" : "1.5px solid #B78520",
                    padding: "10px 20px",
                    borderRadius: "200px",
                    fontWeight: 500,
                    cursor: "pointer",
                    color: label === activeFilter ? "white" : "#000",
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  {label}
                </button>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "transparent",
                border: "1px solid #B78520",
                borderRadius: "200px",
                padding: "8px 16px",
                width: 250,
              }}
            >
              <span role="img" aria-label="search">
                <img src={SearchIcon} style={{ marginBottom: -5 }} />
              </span>
              <input
                type="text"
                placeholder="Keywords..."
                style={{
                  border: "none",
                  outline: "none",
                  paddingLeft: 8,
                  flex: 1,
                  background: "transparent",
                  fontStyle: "italic",
                }}
              />
            </div>
          </div>

          {/* Blog Cards Grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "24px",
            }}
          >
            {Articles.map((article) => (
              <div
                key={article.id}
                style={{
                  backgroundColor: "transparent",
                  borderRadius: "12px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div style={{ position: "relative" }}>
                  <img
                    src={article.image}
                    alt={article.title}
                    style={{
                      width: "100%",
                      height: 180,
                      objectFit: "cover",
                      borderRadius: 10,
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: 12,
                      right: 12,
                      background: "#fff",
                      color: "#093863",
                      fontSize: 14,
                      fontWeight: 500,
                      padding: "4px 8px",
                      borderRadius: 4,
                    }}
                  >
                    {article.label}
                  </span>
                </div>
                <div
                  style={{
                    padding: 16,
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontSize: 15,
                        color: "#1B1B1B",
                        fontWeight: 300,
                        margin: 0,
                      }}
                    >
                      {article.category}{" "}
                    </p>
                    <p
                      style={{
                        fontSize: 15,
                        color: "#1B1B1B",
                        fontWeight: 300,
                        margin: 0,
                      }}
                    >
                      {article.date}
                    </p>
                  </div>

                  <h3
                    style={{
                      margin: 0,
                      fontSize: 16,
                      fontWeight: 500,
                      color: "#004E89",
                    }}
                  >
                    {article.title}
                  </h3>
                  <button
                    style={{
                      marginTop: "auto",
                      padding: "10px 16px",
                      borderRadius: 50,
                      border: "1.5px solid #B78520",
                      backgroundColor: "transparent",
                      color: "#2E2E2E",
                      fontWeight: 500,
                      cursor: "pointer",
                      alignSelf: "start",
                      fontSize: 16,
                      transition: "transform 0.2s ease, background 0.2s ease",
                    }}
                    onMouseDown={(e) => {
                      e.currentTarget.style.transform = "scale(0.96)";
                    }}
                    onMouseUp={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  >
                    Read More <span style={{ color: "#B78520" }}>→</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* right content */}
        <div
          style={{
            width: "30%",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {/* Categories */}
          <div
            style={{
              backgroundColor: "transparent",
              padding: "20px",
              borderRadius: "12px",
              border: "1px solid #2E2E2E4D",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <p
              style={{
                fontSize: 25,
                fontWeight: 600,
                color: "#007F5F",
                marginTop: -5,
                marginBottom: -2,
              }}
            >
              Categories
            </p>
            {categories.map((category, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  borderBottom: idx !== 4 ? "1px solid #2E2E2E4D" : "none",
                  paddingBottom: 8,
                  paddingTop: 8,
                }}
                onClick={() => navigate(`/newsandupdatedetail/${category}`)}
              >
                <span
                  style={{ color: "#004E89", fontSize: 18, fontWeight: 500 }}
                >
                  {category}
                </span>
                <span style={{ color: "#004E89", fontSize: 18 }}>→</span>
              </div>
            ))}
          </div>

          {/* Recent News */}
          <div
            style={{
              backgroundColor: "transparent",
              padding: "20px",
              borderRadius: "12px",
              border: "1px solid #2E2E2E4D",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <p
              style={{
                fontSize: 18,
                fontWeight: 600,
                color: "#007F5F",
                marginTop: -5,
                marginBottom: -2,
              }}
            >
              Recent News
            </p>
            {recentNews.map((news, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  gap: "12px",
                  borderBottom: idx !== 2 ? "1px solid #2E2E2E4D" : "none",
                  paddingBottom: 12,
                  cursor: "pointer",
                }}
              >
                <img
                  src={news.img}
                  alt={news.title}
                  style={{
                    width: 78,
                    height: 78,
                    borderRadius: 6,
                    objectFit: "cover",
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      background: "transparent",
                      color: "#2E2E2ECC",
                      border: "1px solid #B78520",
                      fontSize: 14,
                      padding: "2px 8px",
                      borderRadius: 4,
                      display: "inline-block",
                      marginBottom: 6,
                      fontWeight: 400,
                    }}
                  >
                    {news.date}
                  </div>
                  <p
                    style={{
                      fontSize: 14,
                      margin: 0,
                      fontWeight: 500,
                      color: "#004E89",
                    }}
                  >
                    {news.title}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Need Help Card */}
          <div
            style={{
              background: "linear-gradient(180deg, #007F5F, #00E5AB)",
              borderRadius: 12,
              padding: "18px 16px",
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontSize: 20,
                fontWeight: 600,
                margin: 0,
                marginBottom: "12px",
              }}
            >
              Need Help? Call Us
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                background: "#fff2",
                borderRadius: "8px",
                padding: "8px 16px",
              }}
            >
              <img
                src={phoneIcon}
                alt="phone"
                style={{ width: 20, height: 20 }}
              />
              <span style={{ fontSize: 18, fontWeight: 600, color: "#fff" }}>
                6662 7676
              </span>
            </div>
          </div>

          {/* Follow Us */}
          <div
            style={{
              background: "linear-gradient(180deg, #004E89, #056DBC)",
              borderRadius: "12px",
              padding: "18px",
              color: "#fff",
            }}
          >
            <p
              style={{
                fontSize: 18,
                fontWeight: 600,
                margin: 0,
                marginBottom: "16px",
              }}
            >
              Follow Us
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
              }}
            >
              {socialLinks.map((link, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 36,
                    width: 36,
                    border: "1.5px solid white",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={link.icon}
                    alt="social"
                    style={{ width: 18, height: 18 }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
